export const MULTIPLE_TASKS = '/transaction/multiple/tasks';
